import {
  InfoList, WarningInfo,
} from '@equifinance/shared';
import { SoleTraderFinancialYearSet } from '../../../../../../contexts/account/IncomeAndEmployment';
import {
  Container, ErrorContainer, InputGroupBreak, PureSectionWrapper,
  SoleTraderFinancialYearSetFields,
} from './AccountantCertificateEvidence';

export function AuditedAnnualAccountEvidence({
  evidences,
  field,
}: {
  evidences: SoleTraderFinancialYearSet
  field: string,
}) {
  const evidenceList = [evidences.latestCompletedYear, evidences.previousCompletedYear];
  const latestEvidenceIndex = evidenceList.filter(Boolean).length - 1;
  const paths = ['latestCompletedYear', 'previousCompletedYear'];
  const labels = ['LATEST COMPLETED FINANCIAL YEAR', 'PREVIOUSLY COMPLETED FINANCIAL YEAR (OPTIONAL)'];
  const fieldPath = (path: string) => `${field}.auditedAccountsEvidence.${path}`;

  return (
    <Container key={evidences.id}>
      <ErrorContainer>
        <WarningInfo>
          <InfoList items={['If using accounts, these must be audited accounts.']} />
        </WarningInfo>
      </ErrorContainer>
      {
        evidenceList.map((ace, index) => (
          !!ace && (
            <>
              <PureSectionWrapper
                title={labels[index]}
              >
                <SoleTraderFinancialYearSetFields field={fieldPath(paths[index])} showNetMonthlyTakeHome={index === 0} />
              </PureSectionWrapper>
              {index < latestEvidenceIndex && <InputGroupBreak />}
            </>
          )
        ))
      }
    </Container>
  );
}
